import { useApplicationStore } from '@/store/application-store'

export default function useStoreErrorHandler () {

  const handleSearchError = (type: string) => {
    const applicationStore = useApplicationStore()
    applicationStore.pushSnackbarMessage({
      header: 'Oops something went wrong',
      text: `Sorry, ${type} isn’t responding right now.`,
      state: 'error'
    })
  }

  return {
    handleSearchError
  }
}